import { Header } from "@components:Header";
import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { SwitchPage } from "@components:SwitchPage";
import { BotSelectionPersistent } from "@modules:BotSelection/BotSelection";
import { Box, Container, Typography } from "@mui/material";
import { UploadTab } from "@pages:app/audio/components/Upload";

import { AppType } from "@:constants";

export const Audio = () => {
  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        padding: "12px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          borderRadius: "30px",
          background: (theme) => theme.palette.common.white,
          flexGrow: 1,
        }}
      >
        <Header
          sx={{
            background: (theme) => theme.palette.common.white,
            borderTopLeftRadius: "30px",
            borderTopRightRadius: "30px",
          }}
          rightSide={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box sx={{ paddingX: "0.5rem" }}>
                <BotSelectionPersistent app={AppType.Audio} />
              </Box>
              <SwitchPage />
            </Box>
          }
          leftSide={
            <Box
              sx={{
                marginLeft: "1.5rem",
              }}
            >
              <SVGInternalIcon
                icon="nemoIcon"
                sx={{
                  width: "120px",
                  height: "120px",
                }}
              />
            </Box>
          }
        />
        <Box
          sx={{
            flex: "1 1 0% !important",
            paddingTop: "100px",
          }}
        >
          <Typography
            sx={{
              color: (theme) => theme.palette.text.primary,
              fontWeight: "bold",
              fontSize: "32px",
              lineHeight: "32px",
              textAlign: "center",
            }}
          >
            Nemo Audio
          </Typography>
          <Typography
            sx={{
              color: (theme) => theme.palette.text.primary,
              marginTop: "10px",
              fontSize: "20px",
              lineHeight: "32px",
              fontWeight: "500",
              textAlign: "center",
            }}
          >
            Transcription and dialogue detection
          </Typography>
          <Container
            maxWidth="lg"
            sx={{
              paddingTop: "2rem",
            }}
          >
            <UploadTab />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};
